import { ActivatedRoute } from '@angular/router';
import { slugifyString } from '../../../common/core/utils/slugify-string';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var HcUrls = /** @class */ (function () {
    /**
     * Create new HcUrls service instance.
     */
    function HcUrls(route) {
        this.route = route;
    }
    /**
     * Create router link array for specified article.
     */
    HcUrls.prototype.getArticleLink = function (article, category) {
        var base = ['/help-center/articles'];
        if (category) {
            if (category.parent_id)
                base.push(category.parent_id);
            base.push(category.id);
        }
        return base.concat([article.id, HcUrls.getSlug(article)]);
    };
    /**
     * Create router link array for specified category.
     */
    HcUrls.prototype.getCategoryLink = function (category) {
        return ['/help-center/categories', category.id, HcUrls.getSlug(category)];
    };
    /**
     * Create router link array for current customer tickets list.
     */
    HcUrls.prototype.getCustomerTicketsListLink = function () {
        return ['/help-center/tickets'];
    };
    HcUrls.prototype.getSearchPageLink = function (query) {
        return ['/help-center/search', query];
    };
    HcUrls.getSlug = function (resource) {
        if (resource.slug) {
            return resource.slug;
        }
        else {
            return slugifyString(resource.title || resource.name);
        }
    };
    HcUrls.ngInjectableDef = i0.defineInjectable({ factory: function HcUrls_Factory() { return new HcUrls(i0.inject(i1.ActivatedRoute)); }, token: HcUrls, providedIn: "root" });
    return HcUrls;
}());
export { HcUrls };
